import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdvertisingPlan } from "@/savaradio/common";

export const initialLoading = {
  get: false,
  create: false,
  update: false
}
export type IsLoading = Record<keyof typeof initialLoading, boolean>;

const initialState: { value?: AdvertisingPlan[], isLoading: IsLoading } = { isLoading: initialLoading }

const advertisingPlanSlice = createSlice({
  initialState,
  name: "advertising_plan_slice",
  reducers: {
    reset: (state, action: PayloadAction<AdvertisingPlan[] | undefined>) => {
      state.value = action.payload
    },
    append: (state, action: PayloadAction<AdvertisingPlan>) => {
      if (!state.value) state.value = [action.payload]
      if (
        !!state.value &&
        !state.value.some(item => item._id === action.payload._id)
      ) {
        state.value = state.value.concat(action.payload)
      }
    },
    merge: (state, action: PayloadAction<AdvertisingPlan>) => {
      if (!!state.value) {
        state.value = state.value.map(item => item._id === action.payload._id ? action.payload : item)
      }
    },
    setLoading: (state, action: PayloadAction<Partial<IsLoading>>) => {
      state.isLoading = {
        ...state.isLoading, ...action.payload
      }
    }
  }
})

export const { append, merge, reset, setLoading } = advertisingPlanSlice.actions
export const advertising_plan_slice = advertisingPlanSlice.reducer